import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import OtherCaseStudy from "../../components/other-case"
import gogleads from "../../assets/img/gogleads.png"
import gsearch from "../../assets/img/google-search-logo.png"
import dads from "../../assets/img/discovery.png"
import youtube from "../../assets/img/youtube-logo-yatay.png"
import villamobil from "../../assets/img/villa-mobil-mockup.png"
import balance from "../../assets/img/balance-time-money.png"
import achievement from "../../assets/img/achievement-female.png"
import aysima from "../../assets/img/teams/35.jpg"
import serife from "../../assets/img/teams/20.jpg"
import bengu from "../../assets/img/teams/17.webp"
import gizem from "../../assets/img/teams/24.jpg"

const ReferancesDetail = () => (
  <Layout>
    <SEO title="Villa Yapı Success Story | Flatart" />
    <div className="referances-detail py60 container" style={{ maxWidth: 950 }}>
      <div className="col-md-12 detail-left">
        <b>SUCCESS STORY</b>
        <h1>Villa Yapı</h1>
        <p>Founded in 1999, Villa Yapı began manufacturing prefabricated houses, offices, construction site buildings, prefabricated social facilities, hospitals, schools, and light steel structures. Continuously growing with countless clients both domestically and internationally, Villa Yapı is a manufacturer that shapes the future of its sector.</p>
      </div>
      <div className="col-md-6 detail-left">
        <div className="provided">
          <h3>Services Provided</h3>
          <div className="provided-box">
            <div className="box">
              <Link to="/digital-ads/"></Link>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                <g id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" transform="translate(0.452 0.373)">
                  <rect id="bound" width="76" height="76" transform="translate(-0.452 -0.373)" fill="none" />
                  <path id="Combined-Shape" d="M52.453,31.233l-2.2,13.227-.008.046a3.161,3.161,0,0,1-3.675,2.544L10.63,40.517a3.161,3.161,0,0,1-2.474-2.241L2.389,18.088a3.161,3.161,0,0,1,3.039-4.029H48.813l1.938-8.306a3.729,3.729,0,0,1,3.632-2.882h6.527a3.729,3.729,0,1,1,0,7.459H57.342Z" transform="translate(4.899 6.203)" fillRule="evenodd" opacity="0.3" />
                  <path id="Combined-Shape-2" data-name="Combined-Shape" d="M9.741,27.482a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,9.741,27.482Zm28.447,0a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,38.188,27.482Z" transform="translate(10.804 38.894)" fillRule="evenodd" />
                </g>
              </svg>
              Digital Ads
            </div>
            <div className="box">
              <Link to="/search-engine-optimization/"></Link>
              <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                  <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                  <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                  <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                </g>
              </svg>
              SEO
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 project-details">
        <h3>Impressum</h3>
        <div className="project-details_list">
          <ul>
            <li>Brand Manager:</li>
            <li>SEO Specialist:</li>
            <li>Adwords Specialist:</li>
            <li>Content Writer:</li>
          </ul>
          <ul>
            <li><img src={gizem} alt="Gizem Altun Bostancı" />Gizem A. Bostancı</li>
            <li><img src={bengu} alt="Bengü Dinçer" />Bengü Dinçer</li>
            <li><img src={serife} alt="Şerife Aytekin" />Şerife Aytekin</li>
            <li><img src={aysima} alt="Aysima Bakırcılar" />Aysima Bakırcılar</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="content-section content row">
        <div className="col-md-6">
          <img src={villamobil} alt="villa yapı mobile mockup" />
        </div>
        <div className="col-md-6">
          <p className="small" style={{ maxWidth: 450, color: "#ea4f6a", textAlign: "left" }}>Success Story</p>
          <h3 style={{ maxWidth: 450, fontSize: 25, textAlign: "left" }}><b>Villa Yapı X Flatart</b></h3>
          <p style={{ maxWidth: 450, textAlign: "left" }}>As Flatart, we began by defining a strategic framework aligned with the brand's ambitious goals and target audience, serving as Villa Yapı's <b>SEO &amp; SEM</b> solution partner.</p>
          <p style={{ maxWidth: 450, textAlign: "left" }}>We focused on increasing brand awareness, generating high-quality organic traffic, and as a natural outcome, driving lead generation.</p>
        </div>
      </div>

      <div className="text-center">
        <p className="small" style={{ color: "#ea4f6a" }}>Success Story</p>
        <h2 style={{ margin: '10px auto 20px', maxWidth: 900, fontSize: 27 }}>43.10% organic traffic growth achieved in 1 year.</h2>
        <p style={{ fontSize: 18, margin: '20px auto 0', maxWidth: 850 }}>Through an SEO-focused content marketing strategy, along with on-page and off-page SEO execution, organic traffic increased by 43.10% in the January 2021 – December 2021 period compared to the previous year.</p>
      </div>

      <div className="text-center">
        <h2 style={{ margin: '50px auto 10px', maxWidth: 850, fontSize: 30 }}><b>The Power of Discovery in Prefab!</b></h2>
        <p style={{ fontSize: 25, margin: '0 auto 30px' }}>Ad Channels</p>
        <div className="col-md-4">
          <img style={{ maxHeight: 120 }} src={gogleads} alt="Google Ads" />
          <p style={{ fontSize: 25, margin: '10px auto 30px' }}>Google Ads</p>
        </div>
        <div className="col-md-4">
          <img style={{ maxHeight: 120 }} src={gsearch} alt="Google search" />
          <p style={{ fontSize: 25, margin: '10px auto 30px' }}>Search</p>
        </div>
        <div className="col-md-4">
          <img style={{ maxHeight: 120 }} src={dads} alt="Discovery Ads" />
          <p style={{ fontSize: 25, margin: '10px auto 30px' }}>Discovery Ads</p>
        </div>
      </div>

      <div className="text-center villa-kutu" style={{ fontSize: 18, margin: '50px auto 150px', maxWidth: 850 }}>
        <p style={{ fontSize: 18, margin: '40px auto' }}>After identifying YouTube as the channel with the highest organic engagement in the prefab sector, we focused our advertising efforts there.</p>
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <img style={{ maxHeight: 50 }} src={youtube} alt="youtube logo" />
        </div>
        <div className="col-md-4"></div>
      </div>

      <div className="referances-detail py60">
        <div className="container manage-google" style={{ padding: '40px 60px' }}>
          <div>
            <div className="col-md-6 manage-google_item">
              <img alt="Working with expert team" src={balance} />
              <div>
                <h3>Working with Senior Experts</h3>
                <p>Your digital presence is managed not by interns or junior staff, but by a team of seasoned specialists in their field.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item">
              <img alt="Creating value" src={achievement} />
              <div>
                <h3>Creating Value</h3>
                <p>We focus on high-impact work to maximize your return on investment and consistently measure the KPIs we set toward that goal.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <OtherCaseStudy />
    <Checkup />
  </Layout>
)

export default ReferancesDetail
